import React, { useState } from 'react';
import { Container, Row, Col, Card, Badge, Button, ButtonGroup } from 'react-bootstrap';

const Menu = () => {
  const [activeCategory, setActiveCategory] = useState('all');

  const categories = [
    { id: 'all', name: 'ყველა', icon: 'fas fa-utensils' },
    { id: 'starters', name: 'საწყისი კერძები', icon: 'fas fa-leaf' },
    { id: 'main', name: 'მთავარი კერძები', icon: 'fas fa-drumstick-bite' },
    { id: 'soups', name: 'წვნიანები', icon: 'fas fa-mug-hot' },
    { id: 'desserts', name: 'საკონდიტრო', icon: 'fas fa-ice-cream' },
    { id: 'drinks', name: 'სასმელები', icon: 'fas fa-wine-glass' }
  ];

  const menuItems = [
    // Starters
    {
      id: 1,
      name: 'აჭარული ხაჭაპური',
      description: 'ტრადიციული ქართული ხაჭაპური ყველით და კარაქით',
      price: 12,
      category: 'main',
      image: 'https://i.ibb.co/MDJqddjk/adjxacha.jpg',
      spicy: false,
      vegetarian: true
    },
    {
      id: 2,
      name: 'ლობიო',
      description: 'ქართული ლობიო ცხვრის ხორცით და სანელებლებით',
      price: 8,
      category: 'starters',
      image: 'https://walnuts.org/wp-content/uploads/2017/09/9e64386da924bdf-4DF8BA02-8EE8-4754-8648B47D92585213.jpg',
      spicy: false,
      vegetarian: false
    },
    {
      id: 3,
      name: 'ბაჟე',
      description: 'ქართული ბაჟე',
      price: 10,
      category: 'starters',
      image: '/images/baje.png',
      spicy: false,
      vegetarian: false
    },

    // Main Dishes
    {
      id: 4,
      name: 'ხინკალი',
      description: 'ტრადიციული ქართული ხინკალი ცხვრის ხორცით',
      price: 18,
      piece: 10,
      category: 'main',
      image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/50/Khinkali_551.jpg/1200px-Khinkali_551.jpg',
      spicy: false,
      vegetarian: false
    },
    {
      id: 5,
      name: 'შქმერული',
      description: 'ქართული შქმერი ხორცით და ბოსტნეულით',
      price: 22,
      category: 'main',
      image: '/images/shqme.png',
      spicy: true,
      vegetarian: false
    },
    {
      id: 6,
      name: 'მწვადი',
      //description: 'ქართული მწვადი',
      price: 25,
      piece: 10,
      category: 'main',
      image: 'images/mwvadi.jpg',
      spicy: false,
      vegetarian: false
    },

    // Soups
    {
      id: 7,
      name: 'ხარჩო',
      description: 'ქათმის ნიგვზიანი ხარჩო',
      price: 15,
      category: 'soups',
      image: '/images/xarcho.jpg',
      spicy: false,
      vegetarian: false
    },
    {
      id: 8,
      name: 'ბორში',
      description: 'წვნიანი სხვადასხვა ბოსტნეულით',
      price: 12,
      category: 'soups',
      image: 'images/borshi.jpeg',
      spicy: false,
      vegetarian: true
    },

    // Desserts
    {
      id: 9,
      name: 'ლობიანი',
      description: '',
      price: 8,
      category: 'main',
      image: '/images/labiani.jpeg',
      spicy: false,
      vegetarian: false
    },
    {
      id: 10,
      name: 'კარტოფილი ფრი',
      description: '',
      price: 6,
      category: 'main',
      image: '/images/kartoshka.jpg',
      spicy: false,
      vegetarian: false
    },

    // Drinks
    {
      id: 11,
      name: 'ლიმონათი',
      description: 'ქართული ლიმონათი',
      price: 4,
      category: 'drinks',
      image: '/images/nataxtaxtax.png',
      spicy: false,
      vegetarian: true
    },
    {
      id: 12,
      name: 'წითელი ღვინო',
      description: 'ქართული ღვინო',
      price: 15,
      category: 'drinks',
      image: '/images/damaleine.jpg',
      spicy: false,
      vegetarian: true
    }
  ];

  const filteredItems = activeCategory === 'all' 
    ? menuItems 
    : menuItems.filter(item => item.category === activeCategory);

  return (
    <div className="py-5">
      <Container>
        {/* Header */}
        <Row className="text-center mb-5">
          <Col>
            <h1 className="display-4 fw-bold text-dark mb-3">ჩვენი მენიუ</h1>
            <p className="lead text-muted">
              განიცადეთ ქართული სამზარეულოს უნიკალური გემოები
            </p>
          </Col>
        </Row>

        {/* Category Filter */}
        <Row className="mb-5">
          <Col>
            <div className="d-flex justify-content-center">
              <ButtonGroup className="flex-wrap">
                {categories.map((category) => (
                  <Button
                    key={category.id}
                    variant={activeCategory === category.id ? 'warning' : 'outline-warning'}
                    onClick={() => setActiveCategory(category.id)}
                    className="fw-bold"
                  >
                    <i className={`${category.icon} me-2`}></i>
                    {category.name}
                  </Button>
                ))}
              </ButtonGroup>
            </div>
          </Col>
        </Row>

        {/* Menu Items */}
        <Row>
          {filteredItems.map((item) => (
            <Col lg={4} md={6} key={item.id} className="mb-4">
              <Card className="h-100 shadow-sm menu-card">
                <div className="position-relative">
                  <Card.Img
                    variant="top"
                    src={item.image}
                    alt={item.name}
                    //style={{ width: '100%', height: 'auto' }}
                    style={{ height: '200px', objectFit: 'cover' }}
                  />
                  <div className="position-absolute top-0 end-0 m-2">
                    <Badge bg="warning" text="dark" className="fs-6 px-3 py-2">
                      ₾{item.price}
                    </Badge>
                  </div>
                  <div className="position-absolute top-0 start-0 m-2">
                    {item.spicy && (
                      <Badge bg="danger" className="me-1">
                        <i className="fas fa-fire"></i> ცხარე
                      </Badge>
                    )}
                    {item.vegetarian && (
                      <Badge bg="success">
                        <i className="fas fa-leaf"></i> ვეგეტარიანული
                      </Badge>
                   )}
                    {item.piece ? (
                      <Badge bg="warning" text="dark" className="me-1">
                        {item.piece} ცალი
                      </Badge>
                    ) : null}
                  </div>
                </div>
                <Card.Body className="d-flex flex-column">
                  <Card.Title className="fw-bold fs-5 mb-2">{item.name}</Card.Title>
                  <Card.Text className="text-muted flex-grow-1">
                    {item.description}
                  </Card.Text>
                  <div className="mt-auto">
                    <Button variant="outline-warning" className="w-100 fw-bold">
                      <i className="fas fa-plus me-2"></i>
                      დამატება
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        {/* Special Note */}
        <Row className="mt-5">
          <Col className="text-center">
            <div className="bg-light p-4 rounded">
              <h5 className="text-warning mb-3">
                <i className="fas fa-info-circle me-2"></i>
                სპეციალური შეთავაზებები
              </h5>
              <p className="text-muted mb-0">
                ყოველ შაბათს ყველა კერძზე 15% ფასდაკლება! 
                დაჯავშნა გააკეთეთ ახლავე და ისარგებლეთ ფასდაკლებით.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Menu;
